module.exports = __webpack_public_path__ + "img/dataservice_sfjdjg.a126495e.png";